// BOOTSTRAP CORE COMPONENTS
import Button from 'mdb-ui-kit';
import Collapse from 'mdb-ui-kit';
import Offcanvas from 'mdb-ui-kit';
import Alert from 'mdb-ui-kit';
import Carousel from 'mdb-ui-kit';
import Modal from 'mdb-ui-kit';
import Popover from 'mdb-ui-kit';
import ScrollSpy from 'mdb-ui-kit';
import Tab from 'mdb-ui-kit';
import Tooltip from 'mdb-ui-kit';
import Toast from 'mdb-ui-kit';

// MDB FREE COMPONENTS
import Input from 'mdb-ui-kit';
import Dropdown from 'mdb-ui-kit';
import Ripple from 'mdb-ui-kit';
import Range from 'mdb-ui-kit';

export {
  Alert,
  Button,
  Carousel,
  Collapse,
  Offcanvas,
  Dropdown,
  Input,
  Modal,
  Popover,
  Ripple,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip,
  Range,
};